module.exports = "/_next/static/images/ourPartnersLogo11-8df12b3292ff4099c2337b858e99565c.webp";